<template>
    <div class="jargon-bg-container">
        <div class="jargon-overlay">
            <div class="jargon">
                <letter-navigation
                        :dict="dict"
                        @getcurrentSelectedIdxFromFirstTerms="currentSelectedIdx = $event; activeLetterIdx = $event;"
                        @currentActiveLetterClick="scrollToFirstTerm($event)"
                        :currentActiveLetter="currentActiveLetter"
                        @setSlidingRightState="slideRight = $event"
                        @setCurrentActiveLetter="currentActiveLetter = $event"
                        :showBack="showDefinition"
                        @getResetFromLetterNavigation="scrollShow = $event"
                        class="letter-navigation">
                </letter-navigation>
                <div v-if="scrollShow" style="overflow:hidden">
                    <virtual-list :start="startIndex-benchNum"
                                  :size="wordSize"
                                  :bench="benchNum"
                                  :remain="remainNum"
                                  :onscroll="onScroll"
                                  class="virtual-scroll"
                                  wclass="virtual-scroll-wrapper"
                                  ref="virtualScroll">
                        <div v-for="(dict_word, index) in dict"
                             :key="index"
                             @click="selectedWord(index, $event)"
                             class="word-item"
                             :class="[{'last-word': index === dict.length - 1},
                                      {'first-word': index === 0},
                                      {'hidden-word': dict_word.term ==='*'}]"
                        >
                            {{ removeCharacters(dict_word.term)}}
                        </div>
                    </virtual-list>
                </div>
                <div v-else>
                    <word-container
                            :currentIdx="currentSelectedIdx"
                            :dict="dict"
                            @getCurrentActiveLetterFromBottomArrows="currentActiveLetter = $event"
                            @getCurrentIdxFromBottomArrows="currentSelectedIdx = $event"
                            :canSlideRight="slideRight"
                            :currentActiveLetter="currentActiveLetter"
                    ></word-container>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import dictionary from '../assets/dictionary.json';
    import WordContainer from "./WordContainer";
    import Word from './Word';
    import LetterNavigation from './LetterNavigation';
    import virtualList from 'vue-virtual-scroll-list';

    export default {
        name: "Jargon",
        data: function () {
            return {
                dict: dictionary.dictionary,
                dictLength: dictionary.dictionary.length,
                currentSelectedIdx: 0,
                currentActiveLetter: 'A',
                activeLetterIdx: 0,
                currentActiveIndex: 0,
                slideRight: true,
                wordWheelTop: 0,
                currentWordWheelTop: 0,
                wordWheelNewTop: 0,
                maxTopWordScroll: 0,
                showDefinition: false,
                canSelectWord: true,
                canPanMove: true,
                canReset: false,
                wheelContainerHeight: 0,
                scrollShow: true,
                startIndex: 0,
                benchNum: 5,//5,
                offsetNum: 5,
                remainNum: 9,// 9
                wordSize: 0,
                isScrolling: true,
                firstAndLastTermsArr: []
            }
        },
        methods: {
            selectedWord: function (index) {
                this.currentSelectedIdx = index;
                // let $currentTarget = $($(".word-item")[index]); // current 15 items loaded
                // let $currentTargetTop = $currentTarget.offset().top;
                // let $virtualScrollHeight = $(".virtual-scroll").height() / 2;
                // let $currentWrapperScrollTop = $(".virtual-scroll-wrapper").position().top;
                // console.log("current height / 2 of container: ", $virtualScrollHeight);
                // console.log("current top of target: ", $currentTargetTop);
                // console.log("current scrollTop of virtual-wrapper: ", $currentWrapperScrollTop);
                let that = this;
                this.isScrolling = false;
                if ($(window).width() > 1024) {
                    this.scrollTo($(".virtual-scroll"), ((index - (this.offsetNum - 1)) * this.wordSize), 750);
                    setTimeout(function () {
                        that.isScrolling = true;
                    }, 350);
                } else {
                    this.scrollTo($(".virtual-scroll"), ((index - (this.offsetNum - 1)) * this.wordSize), 650);
                    setTimeout(function () {
                        that.isScrolling = true;
                    }, 350);
                }

                setTimeout(function () {
                    that.startIndex = index;
                    that.scrollShow = false;
                    that.showDefinition = true;
                    that.currentActiveLetter = that.dict[that.currentSelectedIdx].term[0];
                }, 750);

            },
            resetWheel: function () {
                this.showDefinition = false;
                this.scrollShow = true;
                if ($(window).width() > 1024) {
                    this.startIndex = this.currentSelectedIdx + (this.benchNum - (this.offsetNum - 1)); // -1 ||' 1 ?
                } else {
                    // console.log("current selected idx", this.currentSelectedIdx + 1);
                    this.startIndex = this.currentSelectedIdx + (this.benchNum - (this.offsetNum - 1)); // -1 ||' 1 ?
                }
            },
            removeCharacters: function (word) {
                return word.replace(/\s+and\s+/, " & ").replace(/\((.*?)\)/, "");
            },
            onScroll: function (event, data) {
                if (this.isScrolling) {
                    let verticalScrollHeight = $(".virtual-scroll").height() / 2;
                    let $windowWidth = $(window).width();
                    let that = this;
                    $(".word-item").each(function () {
                        let currentTarget = $(this);
                        let currentTop = 0;
                        if ($windowWidth >= 768) {
                            currentTop = currentTarget.offset().top - currentTarget.height();
                        } else {
                            currentTop = currentTarget.offset().top - currentTarget.height() * 2;
                        }
                        let currentBottom = currentTop + currentTarget.height();
                        if (currentTop < verticalScrollHeight && currentBottom > verticalScrollHeight) {
                            currentTarget.addClass("center-word");
                            let currentTargetText = currentTarget.text().trim();
                            let currentIdx = that.findTermIdx(currentTargetText);
                            if (that.isScrolling) {
                                if ((that.binarySearchForIdx(currentIdx) !== -1)) {
                                    that.currentActiveLetter = currentTargetText[0];
                                    that.activeLetterIdx = currentIdx;
                                }
                            }

                        } else {
                            currentTarget.removeClass("center-word");
                        }
                    });
                    let threshold = 0;
                    if ($windowWidth > 1024) {
                        threshold = data.offsetAll - (8.5 * this.centerWordHeight);
                    } else {
                        threshold = data.offsetAll - (7 * this.centerWordHeight);
                    }
                    if (data.offset >= threshold && this.$refs.virtualScroll) {
                        this.$refs.virtualScroll.setScrollTop(threshold);
                    }
                    // console.log("this is executed. ");
                }
                // if current idx in first letters than change the letters corresponding to the dict array
            },
            firstAndLastTerms: function () {
                let firstTermsObj = {};
                for (let i = 0; i < this.dict.length; i++) {
                    if (this.dict[i].term === "*") continue;
                    let letter = this.isLetter(this.dict[i].term[0]);
                    let char = '';
                    if (letter !== "*") {
                        char = letter ? this.dict[i].term[0] : "#";
                    }
                    if (!(char in firstTermsObj)) {
                        firstTermsObj[char] = i;
                    }
                }

                let firstTerms = [];
                Object.keys(firstTermsObj).forEach(function (key) {
                    firstTerms.push(firstTermsObj[key], firstTermsObj[key] + 1, firstTermsObj[key] + 2);

                });
                let firstTermsCopy = firstTerms.slice();
                let lastTerms = [];
                for (let i = 1; i < firstTermsCopy.length; i++) {
                    lastTerms.push(firstTermsCopy[i] - 1, firstTermsCopy[i] - 2, firstTermsCopy[i] - 3);
                }
                // console.log(lastTerms);
                // console.log("first terms: ", firstTerms);
                // console.log("last terms: ", lastTerms);
                // console.log(firstTerms.concat(lastTerms));
                // return firstTerms.concat(lastTerms);
                // console.log(firstTerms.concat(lastTerms));
                return firstTerms.concat(lastTerms);
            },
            isLetter: function (str) {
                return str.length === 1 && str.match(/[a-z]/i);
            },
            scrollTo: function (element, to, duration) {
                let start = element.scrollTop(),
                    change = to - start,
                    currentTime = 0,
                    increment = 20;
                let that = this;
                let animateScroll = function () {
                    currentTime += increment;
                    let val = that.easeInOutQuad(currentTime, start, change, duration);
                    element.scrollTop(val);
                    if (currentTime < duration) {
                        setTimeout(animateScroll, increment);
                    }
                };
                animateScroll();
            },
            easeInOutQuad: function (t, b, c, d) {
                //t = current time
                //b = start value
                //c = change in value
                //d = duration
                t /= d / 2;
                if (t < 1) return c / 2 * t * t + b;
                t--;
                return -c / 2 * (t * (t - 2) - 1) + b;
            },
            findTermIdx: function (term) {
                for (let i = 0; i < this.dict.length; i++) {
                    if (this.dict[i].term.toLowerCase().indexOf(term.toLowerCase()) == 0) {
                        return i;
                    }
                }
                return 0;
            },
            scrollToFirstTerm: function (e) {
                this.isScrolling = false;
                let that = this;
                if ($(window).width() > 1024) {
                    this.scrollTo($(".virtual-scroll"), ((e - (this.offsetNum - 1)) * this.wordSize), 500);
                    setTimeout(function () {
                        that.isScrolling = true;
                    }, 600);
                } else {
                    this.scrollTo($(".virtual-scroll"), ((e - (this.offsetNum - 1)) * this.wordSize), 500);
                    setTimeout(function () {
                        that.isScrolling = true;
                    }, 600);
                }
            },
            binarySearchForIdx: function (item) {
                let list = this.firstAndLastTermsArr;
                let min = 0;
                let max = list.length - 1;
                let guess;
                let bitwise = (max <= 2147483647) ? true : false;
                if (bitwise) {
                    while (min <= max) {
                        guess = (min + max) >> 1;
                        if (list[guess] === item) {
                            return guess;
                        }
                        else {
                            if (list[guess] < item) {
                                min = guess + 1;
                            }
                            else {
                                max = guess - 1;
                            }
                        }
                    }
                } else {
                    while (min <= max) {
                        guess = Math.floor((min + max) / 2);
                        if (list[guess] === item) {
                            return guess;
                        }
                        else {
                            if (list[guess] < item) {
                                min = guess + 1;
                            }
                            else {
                                max = guess - 1;
                            }
                        }
                    }
                }

                return -1;
            }

        },
        components: {
            "word":
            Word,
            "word-container":
            WordContainer,
            "letter-navigation":
            LetterNavigation,
            'virtual-list':
            virtualList
        }
        ,
        watch: {
            scrollShow: function () {
                if (this.scrollShow) {
                    this.resetWheel();
                }
            },
            letterFromNavigation: function () {
                if ($(window).width() > 1024) {
                    this.scrollTo($(".virtual-scroll"), ((this.activeLetterIdx - (this.benchNum - 1)) * this.wordSize), 500);
                } else {
                    this.scrollTo($(".virtual-scroll"), ((this.activeLetterIdx - (this.benchNum - 2)) * this.wordSize), 500);
                }
            }
        },
        mounted: function () {
            //  scroll cursor
            //     $(".word-container").on("mousedown", function (e) {
            //         e.preventDefault();
            //         $(this).removeClass("mouseUp");
            //         $(this).addClass("mouseDown");
            //     });
            //     $(".word-container").on("mouseup", function () {
            //         $(this).removeClass("mouseDown");
            //         $(this).addClass("mouseUp");
            //     });
            //     $(".word-container").on("mouseleave", function () {
            //         $(this).removeClass("mouseDown");
            //         $(this).addClass("mouseUp");
            //     });

            // this.scrollWithMouse();
            this.firstAndLastTermsArr = this.firstAndLastTerms().sort(function (a, b) {
                return a - b
            });
            this.startIndex = 0; // (this.dict.length / 2);
            this.wordSize = $($(".word-item")[0]).height();
            // console.log("word size", this.wordSize);
            let that = this;
            this.$nextTick(function () {
                $(window).resize(function () {
                    if ($(window).width() > 1024) {
                        that.remainNum = 9;
                        that.benchNum = 5;
                    } else {
                        that.remainNum = 12;
                        that.benchNum = 7;
                    }
                    that.wordSize = $($(".word-item")[0]).height();
                    that.$forceUpdate();
                });
            });
            $($(".word-item")[6]).addClass("center-word");
            this.centerWordHeight = $($(".word-item")[6]).height() * 1.05;
        }
    }
</script>

<style scoped lang="scss">
    .hidden-word {
        opacity: 0;
        pointer-events: none;
    }

    .jargon-overlay {
        overflow: hidden;
        -ms-overflow-style: none;
        width: 1px;
        min-width: 100%;
    }

    .virtual-scroll {
        right: 0;
        left: 0;
        text-align: center;
        font-family: "Frutiger LT W01_77 Black Cond", 'Avenir', Helvetica, Arial, sans-serif;
        color: grey;
        overflow-x: hidden;
        -ms-overflow-style: none;
        position: relative;
        overflow-y: scroll;
        width: 1px;
        min-width: 100%;
        @media only screen and (min-width: 320px) {
            -webkit-overflow-scrolling: touch;
            margin: 0 auto;
        }
        @media only screen and (min-width: 480px) {
            margin-right: -16px;
        }
    }

    .word-item {
        text-align: center;
        position: relative;
        display: block;
        text-transform: uppercase;
        line-height: 1.27em;
        &:hover {
            cursor: pointer;
        }
        @media only screen and (min-width: 320px) {
            font-size: 23px;
        }
        @media only screen and (min-width: 480px) {
            font-size: 28px;
        }
        @media only screen and (min-width: 768px) {
            font-size: 40px;
        }
        @media only screen and (min-width: 1024px) {
            font-size: 42px;
        }
        @media only screen and (min-width: 1200px) {
            font-size: 43px;
        }
    }

    .center-word {
        color: #323232;
        transform: scale(1.05);
        transition: transform 0.5s;
    }

    .jargon-bg-container {
        background: url('../assets/word-background.jpg') no-repeat;
        background-size: cover;
        &:before {
            content: "";
            background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 60%, rgba(255, 255, 255, 0) 100%);
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            pointer-events: none;
            @media only screen and (min-width: 320px) {
                height: 110px;
            }
            @media only screen and (min-width: 480px) {
                height: 135px;
            }
        }
        &:after {
            content: "";
            background: linear-gradient(to top, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 100%);
            width: 100%;
            position: absolute;
            left: 0;
            z-index: 10;
            pointer-events: none;
            @media only screen and (min-width: 320px) {
                height: 50px;
                bottom: 0;
            }
            @media only screen and (min-width: 480px) {
                height: 120px;
            }
        }
        @media only screen and (min-width: 1200px) {
            background-position: 0 -14px;
        }
    }

    .jargon {
        position: relative;
        max-width: 800px;
        margin: 0 auto;
        @media only screen and(min-width: 320px) {
            height: 440px;
        }
        @media only screen and (min-width: 768px) {
            height: 600px
        }
    }

    .active {
        height: 420px;
        margin-top: 10px;
    }

    .mouseDown {
        cursor: grabbing;
    }

    .mouseUp {
        cursor: grab;
    }

    .slide-right-leave-active,
    .slide-right-enter-active {
        transition: 0.65s;
    }

    .slide-right-enter {
        transform: translate(150%, 0);
    }

    .slide-right-leave-to {
        transform: translate(-150%, 0);
    }

    .slide-left-leave-active,
    .slide-left-enter-active {
        transition: 0.65s;
    }

    .slide-left-enter {
        transform: translate(-150%, 0);
    }

    .slide-left-leave-to {
        transform: translate(150%, 0);
    }

    /* left arrow link*/

    .link-slide-left-leave-active,
    .link-slide-left-enter-active {
        transition: 0.35s;
    }

    .link-slide-left-enter {
        transform: translate(-500%, 0);
    }

    .link-slide-left-leave-to {
        transform: translate(500%, 0);
    }

    /* right arrow link */

    .link-slide-right-leave-active,
    .link-slide-right-enter-active {
        transition: 0.35s;
    }

    .link-slide-right-enter {
        transform: translate(500%, 0);
    }

    .link-slide-right-leave-to {
        transform: translate(-500%, 0);
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .75s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    ::-webkit-scrollbar {
        width: 0px; /* remove scrollbar space */
        background: transparent; /* optional: just make scrollbar invisible */
    }

    /* optional: show position indicator in red */
    ::-webkit-scrollbar-thumb {
        background: #FF0000;
    }
</style>



// WEBPACK FOOTER //
// src/components/Jargon.vue